<template>
	<div class="expert-search">
		<div>
			<search @goSearch="startSearch"></search>

		</div>
		<van-empty image="search" :description="'暂无相关内容'" v-if="isempty"/>
		<div class="expertsList" v-else>
			<template v-for="(item,index) in speakerList" >
				<expert-info :expertInfo="item" :key="index"></expert-info>				
			</template>
		</div>
		<div class="footerHeight">
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
	import Search from '../../components/Search';
	import ExpertInfo from '../../components/Expert/ExpertInfo';
	import {ExpertSpeakers,ExpertSearch} from '../../config/interface.js';
	import Footer from '@/components/Footer.vue';
	export default{
		components:{
			Search,
			ExpertInfo,
			Footer
		},
		data(){
			return{
				isempty:false,
				meeting_id:0,
				speakerList:[],
				name:'',

			}
		},
		mounted(){
			this.name=this.$route.query.name;
			if(this.name=='speaker'){
				this.meeting_id=this.$route.query.id;
				this.checkSpeaker(' ')
			}
		},
		methods:{
			//搜索
			startSearch(words){
				this.name=='speaker'?this.checkSpeaker(words):'';
				this.name!='speaker'&&words!=''?this.checkExpert(words):''
				words==''&&this.name!='speaker'?this.speakerList=[]:''
			},
			//讲者搜索(某个会议的专家)
			checkSpeaker(words){
				this.$store.dispatch('isShowLoading',true);
				const url=ExpertSpeakers;
				const method='POST'
				let params={
					keywords:words,
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.speakerList=data;
						this.isempty=!this.speakerList.length;
					
					
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//专家搜索(所有专家)
			checkExpert(words){
				this.$store.dispatch('isShowLoading',true);
				const url=ExpertSearch;
				const method='POST';
				let params={
					keywords:words
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.speakerList=data;
						this.isempty=!this.speakerList.length;
					}
					this.$store.dispatch('isShowLoading',false);
				})
			}

		}
	}
</script>
<style lang="scss" scoped>
	.expert-search{
		position: relative;
		min-height:100%;
		.expertsList{
			padding:0px 20px;
			.expertInfo-component:last-child{
				border:0px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Expert/Search.vue